/***************************************************************
6/9/2017
Alexander Self
Timesheet Edit list
- List of timesheets for each employee
***************************************************************/
import React from 'react';
import { FloatingButton } from '../../inputs';

const TimesheetEditList = ({ timesheets, employee, fetchTimesheetToEdit }) => {
  return (
    <ul className="edit-timesheets">
      {
        timesheets.map((ts) => (
          <li key={ts.timesheetID} className="edit-timesheets-item">
            <div className="card">
              <center>
                <b>{ ts.date.split('T')[0] }</b> <br />
                <FloatingButton color={'blue'} icon={'mode_edit'} onclick={() => fetchTimesheetToEdit(ts.timesheetID, employee.eid)} />
              </center>
            </div>
          </li>
        ))
      }
    </ul>
  );
};

export default TimesheetEditList;














/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/edit/timesheet_edit_list.js